(function () {
  var DAY1 = {
    FL: 1, GA: 1, AL: 1, SC: 1, NC: 1, TN: 1, MS: 1, LA: 1, AR: 1, TX: 1,
    OK: 1, MO: 1, IL: 1, IN: 1, OH: 1, KY: 1, WV: 1, VA: 1, PA: 1, MI: 1,
    WI: 1, IA: 1, KS: 1, WA: 1, OR: 1, ID: 1, NV: 1, CA: 1, UT: 1, AZ: 1
  };
  var DAY2 = {
    NY: 1, CT: 1, RI: 1, MA: 1, VT: 1, NH: 1, ME: 1, NJ: 1, DE: 1, MD: 1,
    ND: 1, SD: 1, NE: 1, CO: 1, NM: 1, MT: 1, WY: 1
  };
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var GEO_KEY = 'ttPdpGeo';
  var ZIP_KEY = 'ttPdpZip';

  // ZIP-centroid coordinates for all active Will-Call pickup hubs (never exposes partner street addresses).
  var HUB_COORDS = {
    'Destin, FL': { hub_slug: 'destin-fl', city_state: 'Destin, FL', zip: '32541', lat: 30.3935, lng: -86.4958 },
    'Antioch, TN': { hub_slug: 'antioch-tn', city_state: 'Antioch, TN', zip: '37013', lat: 36.0400, lng: -86.6400 },
    'Talladega, AL': { hub_slug: 'talladega-al', city_state: 'Talladega, AL', zip: '35160', lat: 33.4300, lng: -86.0900 },
    'Bethel, CT': { hub_slug: 'bethel-ct', city_state: 'Bethel, CT', zip: '06801', lat: 41.3712, lng: -73.4140 },
    'Columbus, OH': { hub_slug: 'columbus-oh', city_state: 'Columbus, OH', zip: '43228', lat: 39.9612, lng: -83.1288 },
    'Adairsville, GA': { hub_slug: 'adairsville-ga', city_state: 'Adairsville, GA', zip: '30103', lat: 34.3687, lng: -84.9341 },
    'Woodbine, GA': { hub_slug: 'woodbine-ga', city_state: 'Woodbine, GA', zip: '31569', lat: 30.9627, lng: -81.7226 },
    'Shreveport, LA': { hub_slug: 'shreveport-la', city_state: 'Shreveport, LA', zip: '71108', lat: 32.4318, lng: -93.7885 },
    'Sparks, NV': { hub_slug: 'sparks-nv', city_state: 'Sparks, NV', zip: '89431', lat: 39.5349, lng: -119.7527 },
    'Reno, NV': { hub_slug: 'sparks-nv', city_state: 'Sparks, NV', zip: '89431', lat: 39.5349, lng: -119.7527 },
    'Seattle, WA': { hub_slug: 'seattle-wa', city_state: 'Seattle, WA', zip: '98503', lat: 47.0379, lng: -122.8232 },
    'Harmon, IL': { hub_slug: 'harmon-il', city_state: 'Harmon, IL', zip: '61042', lat: 41.7100, lng: -89.5500 },
    'Jasper, GA': { hub_slug: 'jasper-ga', city_state: 'Jasper, GA', zip: '30143', lat: 34.4600, lng: -84.4200 },
    'Kenly, NC': { hub_slug: 'kenly-nc', city_state: 'Kenly, NC', zip: '27542', lat: 35.5900, lng: -78.1200 },
    'Madisonville, KY': { hub_slug: 'madisonville-ky', city_state: 'Madisonville, KY', zip: '42431', lat: 37.3300, lng: -87.5000 }
  };

  var STATE_CENTROIDS = {
    AL: [32.8067, -86.7911], AZ: [33.7298, -111.4312], AR: [34.9697, -92.3731], CA: [36.1162, -119.6816],
    CO: [39.0598, -105.3111], CT: [41.5978, -72.7554], DE: [39.3185, -75.5071], DC: [38.8974, -77.0268],
    FL: [27.7663, -81.6868], GA: [33.0406, -83.6431], ID: [44.2405, -114.4788], IL: [40.3495, -88.9861],
    IN: [39.8494, -86.2583], IA: [42.0115, -93.2105], KS: [38.5266, -96.7265], KY: [37.6681, -84.6701],
    LA: [31.1695, -91.8678], ME: [44.6939, -69.3819], MD: [39.0639, -76.8021], MA: [42.2302, -71.5301],
    MI: [43.3266, -84.5361], MN: [45.6945, -93.9002], MS: [32.7416, -89.6787], MO: [38.4561, -92.2884],
    MT: [46.9219, -110.4544], NE: [41.1254, -98.2681], NV: [38.3135, -117.0554], NH: [43.4525, -71.5639],
    NJ: [40.2989, -74.5210], NM: [34.8405, -106.2485], NY: [42.1657, -74.9481], NC: [35.6301, -79.8064],
    ND: [47.5289, -99.7840], OH: [40.3888, -82.7649], OK: [35.5653, -96.9289], OR: [44.5720, -122.0709],
    PA: [40.5908, -77.2098], RI: [41.6809, -71.5118], SC: [33.8569, -80.9450], SD: [44.2998, -99.4388],
    TN: [35.7478, -86.6923], TX: [31.0545, -97.5635], UT: [40.1500, -111.8624], VT: [44.0459, -72.7107],
    VA: [37.7693, -78.1700], WA: [47.4009, -121.4905], WV: [38.4912, -80.9545], WI: [44.2685, -89.6165],
    WY: [42.7560, -107.3025]
  };

  function digitsZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 5);
  }

  function stateFromZip(zip) {
    var n = parseInt(digitsZip(zip), 10);
    if (!n) return '';
    if (n >= 35000 && n <= 36999) return 'AL';
    if (n >= 99500 && n <= 99999) return 'AK';
    if (n >= 85000 && n <= 86599) return 'AZ';
    if (n >= 71600 && n <= 72999) return 'AR';
    if (n >= 90000 && n <= 96199) return 'CA';
    if (n >= 80000 && n <= 81699) return 'CO';
    if (n >= 6000 && n <= 6999) return 'CT';
    if (n >= 19700 && n <= 19999) return 'DE';
    if (n >= 20000 && n <= 20599) return 'DC';
    if (n >= 32000 && n <= 34999) return 'FL';
    if ((n >= 30000 && n <= 31999) || (n >= 39800 && n <= 39999)) return 'GA';
    if (n >= 96700 && n <= 96899) return 'HI';
    if (n >= 83200 && n <= 83899) return 'ID';
    if (n >= 60000 && n <= 62999) return 'IL';
    if (n >= 46000 && n <= 47999) return 'IN';
    if (n >= 50000 && n <= 52899) return 'IA';
    if (n >= 66000 && n <= 67999) return 'KS';
    if (n >= 40000 && n <= 42799) return 'KY';
    if (n >= 70000 && n <= 71499) return 'LA';
    if (n >= 3900 && n <= 4999) return 'ME';
    if (n >= 20600 && n <= 21999) return 'MD';
    if ((n >= 1000 && n <= 2799) || (n >= 5500 && n <= 5599)) return 'MA';
    if (n >= 48000 && n <= 49999) return 'MI';
    if (n >= 55000 && n <= 56799) return 'MN';
    if (n >= 38600 && n <= 39799) return 'MS';
    if (n >= 63000 && n <= 65899) return 'MO';
    if (n >= 59000 && n <= 59999) return 'MT';
    if (n >= 68000 && n <= 69399) return 'NE';
    if (n >= 88900 && n <= 89899) return 'NV';
    if (n >= 3000 && n <= 3899) return 'NH';
    if (n >= 7000 && n <= 8999) return 'NJ';
    if (n >= 87000 && n <= 88499) return 'NM';
    if ((n >= 500 && n <= 599) || (n >= 10000 && n <= 14999)) return 'NY';
    if (n >= 27000 && n <= 28999) return 'NC';
    if (n >= 58000 && n <= 58899) return 'ND';
    if (n >= 43000 && n <= 45999) return 'OH';
    if (n >= 73000 && n <= 74999) return 'OK';
    if (n >= 97000 && n <= 97999) return 'OR';
    if (n >= 15000 && n <= 19699) return 'PA';
    if (n >= 2800 && n <= 2999) return 'RI';
    if (n >= 29000 && n <= 29999) return 'SC';
    if (n >= 57000 && n <= 57799) return 'SD';
    if (n >= 37000 && n <= 38599) return 'TN';
    if ((n >= 75000 && n <= 79999) || (n >= 88500 && n <= 88599)) return 'TX';
    if (n >= 84000 && n <= 84799) return 'UT';
    if (n >= 5000 && n <= 5999) return 'VT';
    if ((n >= 20100 && n <= 20199) || (n >= 22000 && n <= 24699)) return 'VA';
    if (n >= 98000 && n <= 99499) return 'WA';
    if (n >= 24700 && n <= 26899) return 'WV';
    if (n >= 53000 && n <= 54999) return 'WI';
    if (n >= 82000 && n <= 83199) return 'WY';
    return '';
  }

  function cleanCityState(raw) {
    var s = String(raw || '').replace(/^TrackTECH(?:\s+Direct)?\s*[\u2014\-]+\s*/i, '').trim();
    if (s === 'Reno, NV') return 'Sparks, NV';
    return s;
  }

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad;
    var dLng = (lng2 - lng1) * toRad;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function visitorCoords(dest) {
    if (!dest) return null;
    var lat = typeof dest.lat === 'number' ? dest.lat : parseFloat(dest.lat);
    var lng = typeof dest.lng === 'number' ? dest.lng : parseFloat(dest.lng);
    if (isFinite(lat) && isFinite(lng)) return { lat: lat, lng: lng };
    var z = digitsZip(dest.zip);
    if (z === '32540' || z === '32541') return { lat: 30.3935, lng: -86.4958 };
    var st = dest.st || stateFromZip(z);
    if (st && STATE_CENTROIDS[st]) {
      return { lat: STATE_CENTROIDS[st][0], lng: STATE_CENTROIDS[st][1] };
    }
    return null;
  }

  function hubMeta(hub) {
    var cityState = cleanCityState(hub && (hub.city_state || hub.public_label || hub.cityState));
    var preset = HUB_COORDS[cityState] || {};
    var lat = hub && isFinite(parseFloat(hub.lat)) ? parseFloat(hub.lat) : preset.lat;
    var lng = hub && isFinite(parseFloat(hub.lng)) ? parseFloat(hub.lng) : preset.lng;
    var qty = hub ? parseInt(hub.in_stock_qty != null ? hub.in_stock_qty : hub.quantity, 10) : 0;
    if (!isFinite(qty)) qty = 0;
    return {
      hub_slug: (hub && hub.hub_slug) || preset.hub_slug || cityState.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
      city_state: cityState,
      zip: (hub && hub.zip) || preset.zip || '',
      lat: lat,
      lng: lng,
      in_stock_qty: qty
    };
  }

  function sortHubsByProximity(hubs, dest) {
    var coords = visitorCoords(dest);
    var list = [];
    var seen = {};
    for (var i = 0; i < (hubs || []).length; i += 1) {
      var m = hubMeta(hubs[i]);
      if (!m.city_state || m.in_stock_qty <= 0 || seen[m.city_state]) continue;
      seen[m.city_state] = 1;
      m.distance = (coords && isFinite(m.lat) && isFinite(m.lng))
        ? haversineMiles(coords.lat, coords.lng, m.lat, m.lng)
        : 999999;
      list.push(m);
    }
    list.sort(function (a, b) {
      if (Math.abs(a.distance - b.distance) > 0.5) return a.distance - b.distance;
      return b.in_stock_qty - a.in_stock_qty;
    });
    return list;
  }

  function sortNativePickupDrawer(dest, closestCity) {
    var coords = visitorCoords(dest);
    var previewCityEls = document.querySelectorAll('[data-tt-pickup-preview-city], pickup-availability .pickup-availability-preview .pickup-title b');
    if (closestCity) {
      for (var p = 0; p < previewCityEls.length; p += 1) {
        previewCityEls[p].textContent = closestCity;
      }
    }
    var listEl = document.querySelector('#Pickup-Availability-Drawer .pickup-availability-list');
    if (!listEl) return;
    var items = Array.prototype.slice.call(listEl.querySelectorAll('li.store-item'));
    if (!items.length) return;
    var scored = items.map(function (li, idx) {
      var nameEl = li.querySelector('.location-name');
      var rawName = li.getAttribute('data-tt-store-city') || (nameEl ? nameEl.textContent : '');
      var cityState = cleanCityState(rawName);
      if (nameEl && cityState) nameEl.textContent = cityState;
      var avail = li.classList.contains('local-available') || li.getAttribute('data-tt-store-available') === 'true';
      var preset = HUB_COORDS[cityState] || {};
      var dist = (coords && isFinite(preset.lat) && isFinite(preset.lng))
        ? haversineMiles(coords.lat, coords.lng, preset.lat, preset.lng)
        : (999999 + idx);
      return { li: li, avail: avail, dist: dist, cityState: cityState };
    });
    scored.sort(function (a, b) {
      if (a.avail !== b.avail) return a.avail ? -1 : 1;
      return a.dist - b.dist;
    });
    for (var j = 0; j < scored.length; j += 1) {
      listEl.appendChild(scored[j].li);
    }
    if (!closestCity && scored[0] && scored[0].avail && scored[0].cityState) {
      for (var k = 0; k < previewCityEls.length; k += 1) {
        previewCityEls[k].textContent = scored[0].cityState;
      }
    }
  }

  function paintProximityPickup(root, dest) {
    var available = root.getAttribute('data-available') === 'true';
    var pickupRow = root.querySelector('[data-tt-pickup-row]');
    var pickupCopy = root.querySelector('[data-tt-pickup-copy]');
    var hubs = root.__ttHubs || [];
    var sorted = available ? sortHubsByProximity(hubs, dest) : [];
    var closest = sorted[0] ? sorted[0].city_state : '';
    if (pickupRow && pickupCopy) {
      if (available && closest) {
        pickupCopy.textContent = 'Pickup available at ' + closest + ' \u2022 Usually ready in 24 hours';
        pickupRow.hidden = false;
      } else if (!available) {
        pickupCopy.textContent = '';
        pickupRow.hidden = true;
      }
    }
    sortNativePickupDrawer(dest, closest);
  }

  function isNoShip(st) {
    return st === 'AK' || st === 'HI';
  }

  function transitDays(st) {
    if (isNoShip(st)) return 0;
    if (!st) return 3;
    if (DAY1[st]) return 1;
    if (DAY2[st]) return 2;
    return 3;
  }

  function nyParts(date) {
    var map = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'long',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return {
      weekday: map.weekday,
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      minute: parseInt(map.minute, 10) || 0,
      second: parseInt(map.second, 10) || 0
    };
  }

  function fromNyYmd(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day, 17, 0, 0));
  }

  function addCalendarDays(parts, count) {
    var utc = fromNyYmd(parts.year, parts.month, parts.day);
    utc.setUTCDate(utc.getUTCDate() + count);
    return nyParts(utc);
  }

  function nextWeekday(parts) {
    var cursor = parts;
    do {
      cursor = addCalendarDays(cursor, 1);
    } while (cursor.weekday === 'Saturday' || cursor.weekday === 'Sunday');
    return cursor;
  }

  function shipDay(now) {
    var parts = nyParts(now);
    var weekend = parts.weekday === 'Saturday' || parts.weekday === 'Sunday';
    if (weekend || parts.hour >= 14) return nextWeekday(parts);
    return parts;
  }

  function addBusinessDays(parts, days) {
    var cursor = parts;
    var added = 0;
    while (added < days) {
      cursor = addCalendarDays(cursor, 1);
      if (cursor.weekday !== 'Saturday' && cursor.weekday !== 'Sunday') added += 1;
    }
    return cursor;
  }

  function ordinal(n) {
    var v = n % 100;
    if (v >= 11 && v <= 13) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }

  function formatArrive(parts) {
    return parts.weekday + ', ' + MONTHS[parts.month - 1] + ' ' + ordinal(parts.day);
  }

  function nyUtcMs(year, month, day, hour, minute) {
    var utc = Date.UTC(year, month - 1, day, hour + 4, minute || 0, 0);
    var i;
    for (i = 0; i < 6; i += 1) {
      var p = nyParts(new Date(utc));
      var delta =
        Date.UTC(year, month - 1, day, hour, minute || 0, 0) -
        Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, 0);
      if (!delta) break;
      utc += delta;
    }
    return utc;
  }

  function cutoffMs(now) {
    var day = shipDay(now);
    return nyUtcMs(day.year, day.month, day.day, 14, 0);
  }

  function formatCountdown(ms) {
    var remain = Math.max(0, ms);
    var totalMin = Math.floor(remain / 60000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return h + 'h ' + m + 'm';
  }

  function arrivalCopy(st) {
    var days = transitDays(st);
    if (!days) return '';
    return formatArrive(addBusinessDays(shipDay(new Date()), days));
  }

  function placeCopy(city, st, zip) {
    var z = digitsZip(zip);
    var bits = [];
    if (city) bits.push(city);
    if (st && z) bits.push(st + ' ' + z);
    else if (st) bits.push(st);
    else if (z) bits.push(z);
    return bits.join(', ');
  }

  function readJson(key) {
    try {
      var raw = sessionStorage.getItem(key) || localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function writeLocal(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function paintEta(root) {
    var st = root.getAttribute('data-tt-st') || '';
    var countEl = root.querySelector('[data-tt-eta-countdown]');
    var dateEl = root.querySelector('[data-tt-eta-date]');
    if (isNoShip(st)) {
      if (countEl) countEl.textContent = '';
      if (dateEl) dateEl.textContent = '';
      return;
    }
    var now = new Date();
    if (countEl) countEl.textContent = formatCountdown(cutoffMs(now) - now.getTime());
    if (dateEl) dateEl.textContent = arrivalCopy(st);
  }

  var etaRoots = [];
  var etaTimer = null;

  function ensureEtaTimer() {
    if (etaTimer) return;
    etaTimer = setInterval(function () {
      var i;
      for (i = 0; i < etaRoots.length; i += 1) paintEta(etaRoots[i]);
    }, 1000);
  }

  function applyDestination(root, dest) {
    var placeEl = root.querySelector('[data-tt-dest-place]');
    var leadEl = root.querySelector('[data-tt-dest-lead]');
    var zipEl = root.querySelector('[data-tt-dest-zip]');
    var city = dest && dest.city ? dest.city : '';
    var st = dest && dest.st ? dest.st : '';
    var zip = dest && dest.zip ? digitsZip(dest.zip) : '';
    var noship = isNoShip(st);
    root.__ttDest = dest || { city: city, st: st, zip: zip };
    root.setAttribute('data-tt-zone', noship ? 'noship' : 'lower48');
    root.setAttribute('data-tt-st', st);
    if (leadEl) leadEl.textContent = noship ? '' : 'Delivers Free to';
    if (placeEl) placeEl.textContent = placeCopy(city, st, zip);
    if (zipEl && zip && zipEl.value.replace(/\D/g, '') !== zip) zipEl.value = zip;
    paintEta(root);
    paintProximityPickup(root, root.__ttDest);
  }

  function fetchJson(url, ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || 2500);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('http');
        return res.json();
      })
      .finally(function () { clearTimeout(timer); });
  }

  function geoFromIpapi(json) {
    if (!json || (json.country !== 'US' && json.country_code !== 'US')) return null;
    var st = String(json.region_code || json.region || '').toUpperCase();
    if (st.length !== 2) st = stateFromZip(json.postal);
    var city = json.city ? String(json.city) : '';
    var zip = digitsZip(json.postal);
    var lat = parseFloat(json.latitude);
    var lng = parseFloat(json.longitude);
    if (!st && !city && !zip) return null;
    return {
      city: city,
      st: st,
      zip: zip,
      lat: isFinite(lat) ? lat : undefined,
      lng: isFinite(lng) ? lng : undefined
    };
  }

  function geoFromZippo(json, zip) {
    var place = json && json.places && json.places[0];
    if (!place) {
      var stOnly = stateFromZip(zip);
      return stOnly ? { city: '', st: stOnly, zip: digitsZip(zip) } : null;
    }
    var lat = parseFloat(place.latitude);
    var lng = parseFloat(place.longitude);
    return {
      city: place['place name'] || '',
      st: String(place['state abbreviation'] || stateFromZip(zip) || '').toUpperCase(),
      zip: digitsZip(zip),
      lat: isFinite(lat) ? lat : undefined,
      lng: isFinite(lng) ? lng : undefined
    };
  }

  function bindStockMap(root) {
    var mapEl = root.querySelector('[data-tt-stock-map]') || (root.parentNode ? root.parentNode.querySelector('[data-tt-stock-map]') : null);
    if (!mapEl) {
      var host = root.closest ? root.closest('.product-info-inventory') : null;
      if (host) mapEl = host.querySelector('[data-tt-stock-map]');
    }
    if (!mapEl) return;
    var map = {};
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    function apply(id) {
      if (id == null || id === '') return;
      var key = String(id);
      if (!Object.prototype.hasOwnProperty.call(map, key)) return;
      var row = map[key];
      var available = typeof row === 'object' && row !== null ? !!row.available : !!row;
      var qty = typeof row === 'object' && row !== null ? parseInt(row.qty, 10) : 0;
      if (typeof row === 'object' && row !== null && row.sku) {
        root.setAttribute('data-tt-sku', String(row.sku));
      }
      if (!qty || qty < 1) qty = 0;
      root.setAttribute('data-available', available ? 'true' : 'false');
      root.__ttHubs = (typeof row === 'object' && row !== null && Array.isArray(row.hubs)) ? row.hubs : [];
      var qtyEl = root.querySelector('[data-tt-stock-qty]');
      var labelEl = root.querySelector('[data-tt-stock-label]');
      if (labelEl) {
        if (available && qty > 0) {
          labelEl.innerHTML = 'In Stock: <span data-tt-stock-qty>' + qty + '</span> Available';
        } else if (available) {
          labelEl.textContent = 'In Stock';
        }
      } else if (qtyEl) {
        qtyEl.textContent = available && qty > 0 ? String(qty) : '';
      }
      paintProximityPickup(root, root.__ttDest);
    }
    var initialVid = root.getAttribute('data-tt-variant-id');
    if (initialVid && Object.prototype.hasOwnProperty.call(map, initialVid)) {
      root.__ttHubs = Array.isArray(map[initialVid].hubs) ? map[initialVid].hubs : [];
    }
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.name !== 'id') return;
      apply(t.value);
    });
    if (window.webvista && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.webvista.subscribe(window.PUB_SUB_EVENTS.variantChange, function (payload) {
        var variant = payload && ((payload.data && payload.data.variant) || payload.variant || payload.currentVariant);
        if (variant && variant.id) apply(variant.id);
      });
    }
  }

  function observePickupElement(root) {
    var pa = document.querySelector('pickup-availability');
    if (!pa || typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(function () {
      paintProximityPickup(root, root.__ttDest);
    });
    obs.observe(pa, { childList: true, subtree: true });
  }

  function init(root) {
    if (!root || root.getAttribute('data-tt-bound') === '1') return;
    root.setAttribute('data-tt-bound', '1');
    bindStockMap(root);
    observePickupElement(root);
    etaRoots.push(root);
    ensureEtaTimer();
    applyDestination(root, { city: '', st: '', zip: '' });

    var zipEl = root.querySelector('[data-tt-dest-zip]');
    function refreshLiveHubAvailability(dest) {
      var apiBase = root.getAttribute('data-tt-api-base') || 'https://tracktech-ops-dashboard.vercel.app';
      var sku = root.getAttribute('data-tt-sku') || '';
      var z = dest && dest.zip ? digitsZip(dest.zip) : '';
      var url = apiBase.replace(/\/$/, '') + '/api/storefront/availability?sku=' + encodeURIComponent(sku) + (z ? '&zip=' + encodeURIComponent(z) : '');
      fetchJson(url, 3000)
        .then(function (data) {
          if (!data || !data.ok) return;
          if (typeof data.totalAvailableQty === 'number' && data.totalAvailableQty > 0) {
            root.setAttribute('data-available', 'true');
            var labelEl = root.querySelector('[data-tt-stock-label]');
            if (labelEl) {
              labelEl.innerHTML = 'In Stock: <span data-tt-stock-qty>' + data.totalAvailableQty + '</span> Available';
            }
          }
          if (Array.isArray(data.regionalHubs) && data.regionalHubs.length > 0 && (!root.__ttHubs || !root.__ttHubs.length)) {
            root.__ttHubs = data.regionalHubs.map(function (h) {
              return {
                city_state: cleanCityState(h.cityState || h.publicLabel),
                in_stock_qty: h.availableQty || 0
              };
            });
          }
          if (data.destination && data.destination.zip && (!dest || !dest.zip)) {
            applyDestination(root, {
              city: data.destination.city || '',
              st: data.destination.state || '',
              zip: data.destination.zip
            });
          } else {
            paintProximityPickup(root, root.__ttDest);
          }
        })
        .catch(function () {});
    }

    function useDest(dest, persist) {
      if (!dest) return;
      applyDestination(root, dest);
      writeSession(GEO_KEY, dest);
      if (persist) writeLocal(ZIP_KEY, dest);
      refreshLiveHubAvailability(dest);
    }

    function lookupZip(zip) {
      var z = digitsZip(zip);
      if (z.length !== 5) return;
      var fallback = { city: '', st: stateFromZip(z), zip: z };
      if (fallback.st) useDest(fallback, true);
      fetchJson('https://api.zippopotam.us/us/' + z, 2500)
        .then(function (json) {
          var dest = geoFromZippo(json, z);
          if (dest) useDest(dest, true);
        })
        .catch(function () {});
    }

    if (zipEl) {
      zipEl.addEventListener('change', function () { lookupZip(zipEl.value); });
      zipEl.addEventListener('input', function () {
        if (digitsZip(zipEl.value).length === 5) lookupZip(zipEl.value);
      });
    }

    var savedZip = readJson(ZIP_KEY);
    if (savedZip && digitsZip(savedZip.zip).length === 5) {
      var z0 = digitsZip(savedZip.zip);
      useDest({
        city: savedZip.city || '',
        st: savedZip.st || stateFromZip(z0),
        zip: z0,
        lat: savedZip.lat,
        lng: savedZip.lng
      }, false);
      if (zipEl) zipEl.value = z0;
      if (!isFinite(parseFloat(savedZip.lat))) lookupZip(z0);
      return;
    }

    var cached = readJson(GEO_KEY);
    if (cached && (cached.st || cached.zip)) {
      useDest(cached, false);
      return;
    }

    fetchJson('https://ipapi.co/json/', 2500)
      .then(function (json) {
        var dest = geoFromIpapi(json);
        if (dest) useDest(dest, false);
        else refreshLiveHubAvailability(null);
      })
      .catch(function () {
        refreshLiveHubAvailability(null);
      });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-tt-pdp-stock-ship]');
    for (var i = 0; i < nodes.length; i += 1) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'id') {
      setTimeout(boot, 50);
    }
  });
})();
